<template>
  <div id="app" class="app">
    <layout v-if="!isAuth"/>
    <auth-layout v-else></auth-layout>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout'
  import AuthLayout from 'components/layout/AuthLayout'
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue'

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      AuthLayout,
      Layout
    },
    computed: {
      isAuth () {
        return this.$route.path.match('auth')
      }
    }
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
  .pull-right {
    float: right;
    display: block;
    height: 100%;
    line-height: 3rem;
  }
  .pull-right a {
    height: 100%;
    line-height: 3rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue